/**
 * Inspection API Repository
 *
 * home_karte_api との通信とデータ変換を担当
 * 現在はモックデータを使用（APIエンドポイント未実装）
 */

import { ENV } from '../../../shared/config/env';
import { createApiClient } from '../../../shared/services/api';
import type { ApiResult } from '../../../shared/types/api';
import type { Inspection } from '../types';
import { allInspections } from './inspectionData';

// 環境変数からAPIベースURLを取得（未設定時はモック）
const API_BASE_URL = ENV.API_BASE_URL;
const USE_MOCK = !API_BASE_URL;

/**
 * デバッグログをFlutter WebViewに送信
 */
const sendDebugLog = (message: string): void => {
  if (process.env.NODE_ENV !== 'production') {
    try {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const webview = (window as any).DebugChannel;
      if (webview?.postMessage) {
        webview.postMessage(message);
      }
      console.log('[Inspection]', message);
    } catch {
      // WebView外での実行時は無視
    }
  }
};

/**
 * Inspection Repository
 */
export const inspectionRepository = {
  /**
   * 点検一覧を取得
   */
  getAll: async (homeId: string): Promise<ApiResult<Inspection[]>> => {
    if (USE_MOCK) {
      // モックモード
      sendDebugLog(`getAll: モックモード使用 (API_BASE_URL未設定)`);
      await new Promise(resolve => setTimeout(resolve, 300));
      sendDebugLog(`getAll: モックデータ返却 (${allInspections.length}件)`);
      return { success: true, data: allInspections };
    }

    sendDebugLog(`getAll: API呼出 homeId=${homeId}`);
    // TODO: APIエンドポイント実装後に有効化
    const client = createApiClient({ baseUrl: API_BASE_URL });
    const result = await client.get<{ inspections: Inspection[] }>(
      `/api/v1/inspections?homeId=${homeId}&page=1&limit=100`
    );

    if (!result.success) {
      return result;
    }

    return { success: true, data: result.data.inspections };
  },

  /**
   * 点検詳細を取得
   */
  getById: async (inspectionId: string): Promise<ApiResult<Inspection | null>> => {
    if (USE_MOCK) {
      // モックモード
      sendDebugLog(`getById: モックモード使用 (API_BASE_URL未設定)`);
      await new Promise(resolve => setTimeout(resolve, 200));
      const inspection = allInspections.find(i => i.id === Number(inspectionId));
      sendDebugLog(`getById: モックデータ返却 inspectionId=${inspectionId} found=${!!inspection}`);
      return { success: true, data: inspection || null };
    }
    sendDebugLog(`getById: API呼出 inspectionId=${inspectionId}`);

    // TODO: APIエンドポイント実装後に有効化
    const client = createApiClient({ baseUrl: API_BASE_URL });
    const result = await client.get<Inspection>(
      `/api/v1/inspections/${inspectionId}`
    );

    if (!result.success) {
      return result;
    }

    return { success: true, data: result.data };
  },
};
